import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessGoalsGoalRoute extends Route {
  @service store;
  @service router;

  beforeModel() {
    return Promise.all([
      this.store.findAll('person'),
      this.store.findAll('initiative'),
    ]);
  }

  model({ goal_id }) {
    return this.store.findRecord('goal', goal_id, {
      include: 'target',
    });
  }

  @action
  error(error) {
    if (error.code === 'NotFoundError') {
      this.router.replaceWith('business.goals.list');
    } else {
      // Let the route above this handle the error.
      return true;
    }
  }
}

export default instrumentRoutePerformance(BusinessGoalsGoalRoute);
